import { Vue } from 'vue-property-decorator'
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import LogoutApi from '@/app/model/api/logoutApi'
import DateClass from '@/app/module/date'
import store from '@/store'
import route from '@/router'
import { routerPath } from '@/app/model/store/domain/const'

class CommonClass {
  public async doLogout () {
    const bodyData = {
      token: Local.getAuthToken()!
    }

    const result = await LogoutApi.doLogout(bodyData)
    // ローカルストレージをクリア
    Session.clear()
    Local.clear()

    // cacheStorageをクリア
    caches.keys().then(function (keys) {
      let promises = []
      // キャッシュストレージを全て削除する
      keys.forEach(function (cacheName) {
        if (cacheName) {
          promises.push(caches.delete(cacheName))
        }
      })
    })

    // 検索状態を保持していたものを削除
    store.commit('fieldState/setListRefile', true)
    store.commit('fieldState/setSearchStatus', 0)
    store.commit('fieldState/setSearchVariety', '')
    store.commit('fieldState/setSearchGrade', '')
    store.commit('fieldState/setSearchRisk', 0)
    store.commit('fieldState/setSearchText', '')

    // ログアウトの際にはフラグをリセットする
    store.commit('setFlagState/setGraphDialogFlag', false)
    store.commit('setFlagState/setAgrinoteImgFlag', false)
    store.commit('setFlagState/setAgrinoteMainImgFlag', false)
    store.commit('setFlagState/setSensorDataFlag', false)
    store.commit('setFlagState/setSelectDataListFlag', false)
    store.commit('setFlagState/setFieldDetailsDataFlag', false)
    store.commit('setFlagState/setModalFieldDetailsDataFlag', false)
    store.commit('setFlagState/setGraphMasterDataFlag', false)
    store.commit('setFlagState/setPlantingIdFlag', false)

    route.go({ path: routerPath.PATH_LOGIN, force: true })
  }

  /* グローバル変数にデータを追加 */
  public setGrowthData (val: any, $event: any) {
    // idからidとstepを切り出す
    let index = val.id.indexOf('/')
    let str = val.id.slice(index + 1)

    let id = str.substr(1)
    let step = str.slice(0, 1)

    // ステージの日付を求める
    let growthDataList = JSON.parse(Session.getGrowthStage()!)
    let growthData = growthDataList[step - 1]
    let plantingDate = DateClass.formingDate(Session.getPlantingDay()!)
    let newDate = new Date(plantingDate.getTime() + (growthData.days * 24 * 60 * 60 * 1000))
    let stageDate = DateClass.toDoubleDigits(newDate.getMonth() + 1) + '/' + DateClass.toDoubleDigits(newDate.getDate())

    // 必要なデータをグローバル変数に格納
    Vue.prototype.$globalGrowthData = growthData
    Vue.prototype.$globalStageDate = stageDate

    Vue.prototype.$globalElX = $event.clientX

    // データ変更フラグ
    store.commit('setFlagState/setGrowthDialogFlag', true)
  }
}

export default new CommonClass()
